var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 2.6a5.4 5.4 0 1 0 0 10.8A5.4 5.4 0 0 0 8 2.6M1.4 8a6.6 6.6 0 1 1 13.2 0A6.6 6.6 0 0 1 1.4 8",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 4.4a.6.6 0 0 1 .6.6v3.23l2.068 1.033a.6.6 0 1 1-.536 1.074l-2.4-1.2A.6.6 0 0 1 7.4 8.6V5a.6.6 0 0 1 .6-.6",
  clipRule: "evenodd"
})));
export default SvgIcSTime;